import React from "react";
import Navbar from "../components/common/Navbar";
import Footer from "../components/other/Footer";
import "../pages/PrivacyPolicy.css";

export default function PrivacyPolicy() {
  return (
    <>
      {/* Header */}
      <header className="header-area">
        <Navbar />
      </header>

      {/* Main Content */}
      <main id="main-content" className="privacy-policy-page" role="main" aria-label="Privacy Policy Content">
        <div className="privacy-content-wrapper">
          {/* Document Header */}
          <section className="privacy-header" aria-labelledby="page-title">
            <h1 className="company-name" id="company-name">AGREYA CAPITAL ADVISORS LLP</h1>
            <h2 className="company-designation" id="company-designation">PORTFOLIO MANAGERS</h2>
            <h3 className="document-title" id="page-title">Privacy Policy</h3>

            <div className="version-info">
              <p>
                <strong>Version:</strong> 1.0
              </p>
              <p>
                <strong>Updated on</strong> 31/08/2026
              </p>
            </div>
          </section>

          {/* Privacy Policy Introduction */}
          <section className="privacy-intro-section">
            <h2>Privacy Policy</h2>

            <p>
              This policy is applicable to the Agreya Capital Advisors LLP ("the Company/Firm hereinafter referred to as Agreya Capital), (SEBI Registration No. INP000006077), a Portfolio Manager registered with the Securities and Exchange Board of India ("SEBI").
            </p>

            <p>
              This Privacy Policy describes how Agreya Capital Advisors LLP collects, uses, discloses and protects information regarding your personal and financial data when you access our website www.agreyacapital.com and mobile applications (collectively referred to as the Digital Platforms)
            </p>

            <p>
              Our Digital Platforms act as a secure, read-only access layer for existing Portfolio Management Services (PMS) clients to view portfolio holdings, monitor real-time performance or download statutory statements
            </p>

            <p>
              This Policy aligns with the Securities and Exchange Board of India (Portfolio Managers) Regulations, 2020, the SEBI Cybersecurity and Cyber Resilience Framework (CSCRF), the Digital Personal Data Protection Act, 2023 ("DPDPA"), and the Information Technology Act, 2000 as applicable.
            </p>
          </section>

          {/* Section 1: Interpretation and Definitions */}
          <section className="privacy-section">
            <h2>1. Interpretation and Definitions</h2>

            <ul className="definitions-list">
              <li>
                <strong>"Account"</strong> means the login credential set (linked to Your registered mobile number) that allows You to access the App.
              </li>
              <li>
                <strong>"App" or "Service"</strong> means the Agreya Capital client application, available on mobile and/or web.
              </li>
              <li>
                <strong>"Client" or "You"</strong> means an existing client of the Company's portfolio management services who is issued access to the App.
              </li>
              <li>
                <strong>"Company", "We", "Us", "Our"</strong> refers to Agreya Capital Advisors LLP having its registered office at 360, 6th Main Rd, near Wipro Signal, Block 1, Koramangala, Bengaluru, Karnataka 560034, SEBI Registration No. INP000006077.
              </li>
              <li>
                <strong>"Personal Data" or "Personal Information"</strong> means any data about an individual who is identifiable by or in relation to such data, as defined under the DPDPA.
              </li>
              <li>
                <strong>"Data Principal"</strong> means the individual to whom the Personal Data relates.
              </li>
              <li>
                <strong>"Service Provider"</strong> means any third party engaged by the Company to process data on our behalf in connection with the App (for example, an SMS/OTP gateway or cloud hosting provider).
              </li>
              <li>
                <strong>"Usage Data"</strong> means data collected automatically through use of the App, such as device identifiers, app version, crash logs, and session activity.
              </li>
              <li>
                <strong>"Books of Account and Records"</strong> means the client records, transaction records, and portfolio data that the Company is required to maintain under the SEBI (Portfolio Managers) Regulations, 2020, independent of the App.
              </li>
            </ul>
          </section>

          {/* Section 2: Scope */}
          <section className="privacy-section">
            <h2>2. Scope</h2>

            <p>
              This Policy covers only the data collected and processed through the App itself. It does not restate the Company's KYC, onboarding, and portfolio-management data practices, which are governed by your Portfolio Management Services agreement, the Disclosure Document, and the Company's obligations under the SEBI (Portfolio Managers) Regulations, 2020. The App is only the client-access layer of records which the Company already holds as your registered Portfolio Manager; it is not an independent point of KYC or financial data collection.
            </p>
          </section>

          {/* Section 3: Personal Data We Collect Through the App */}
          <section className="privacy-section">
            <h2>3. Personal Data We Collect Through the App</h2>

            <h3>3.1 Data collected at login</h3>
            <p>
              Registered mobile number — used solely to send a one-time password (OTP) for login verification. The mobile number is not stored by the App after OTP verification is complete; it is matched against Our existing client records for authentication purposes only.
            </p>

            <h3>3.2 Biometric authentication</h3>
            <p>
              For return visits, the App may offer biometric login (fingerprint or face unlock) as a convenience feature. This authentication is performed entirely by Your device's operating system (e.g., Android Biometric Prompt or Apple Face ID/Touch ID). We do not receive, collect, transmit, or store Your biometric data, biometric templates or any representation thereof. Your biometric data never leaves Your device.
            </p>

            <h3>3.3 Query / support content</h3>
            <p>
              Support queries and requests submitted through the App are routed directly to our client servicing team via email as info@agreyacapital.com. All follow-up communications and resolutions will be provided through email. As of the date of this Policy, the App does not support file or document attachments to queries.
            </p>

            <h3>3.4 Usage and device data</h3>
            <p>
              We may automatically collect limited technical data needed to operate and secure the App, such as device type, operating system version, app version, IP address, session timestamps, and crash/diagnostic logs.
            </p>

            <h3>3.5 Data displayed but not collected via the App</h3>
            <p>
              The App displays portfolio performance figures of the particular client (1-month, 3-month, since-inception, and other period returns), holdings summaries and downloadable reports. We keep your identity documents, bank details, demat account information, and transaction history separately under your main investment contract, not through this app. Therefore, this data is governed by our primary client data policy, not this App Privacy Policy.
            </p>
          </section>

          {/* Section 4: How We Use Your Data */}
          <section className="privacy-section">
            <h2>4. How We Use Your Data</h2>

            <ul className="usage-list">
              <li>To authenticate Your login and provide secure access to Your portfolio information.</li>
              <li>To retrieve and display Your portfolio performance and reports within the App.</li>
              <li>To route and resolve queries or service requests You raise through the App.</li>
              <li>To maintain the security, stability, and integrity of the App (fraud prevention, diagnostics, abuse prevention).</li>
              <li>To comply with Our obligations under SEBI regulations, the DPDPA, and other applicable law.</li>
            </ul>

            <p>
              We do not use App data for marketing, advertising, profiling, or any purpose unrelated to servicing Your existing PMS relationship. We do not sell or rent Your Personal Data to any third party.
            </p>
          </section>

          {/* Section 5: Legal Basis for Processing */}
          <section className="privacy-section">
            <h2>5. Legal Basis for Processing (DPDPA, 2023)</h2>

            <p>
              Under the Digital Personal Data Protection Act, 2023, We process Your Personal Data on the following grounds:
            </p>

            <ul className="legal-basis-list">
              <li><strong>Consent</strong> – where You provide Your mobile number for OTP-based login, which constitutes Your consent to that specific, limited processing.</li>
              <li><strong>Legitimate use</strong> – processing that is necessary for the Company to perform its obligations as Your registered Portfolio Manager, including servicing queries You voluntarily raise.</li>
            </ul>

            <p>
              You may withdraw consent for App-based login at any time by discontinuing use of the App and contacting Us to disable App access; this will not affect the Company's separate, lawful processing of Your data under Your PMS agreement.
            </p>
          </section>

          {/* Section 6: Data Retention */}
          <section className="privacy-section">
            <h2>6. Data Retention</h2>

            <p>
              We distinguish between App-layer technical data and records that form part of the Company's regulatory records.
            </p>

            <table className="retention-table" aria-label="Data Retention Information">
              <thead>
                <tr>
                  <th scope="col">Data Category</th>
                  <th scope="col">Retention Period</th>
                  <th scope="col">Basis</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Registered mobile number (OTP login)</td>
                  <td>Not stored after OTP verification</td>
                  <td>Used transiently for authentication only</td>
                </tr>
                <tr>
                  <td>App session / device / crash logs</td>
                  <td>Up to 24 months</td>
                  <td>Security monitoring, diagnostics, troubleshooting</td>
                </tr>
              </tbody>
            </table>

            <p className="retention-note">
              The 24-month figure applies only to App-layer technical/usage data. It does not shorten, limit, or override the Company's statutory obligation to retain client books of account, transaction records, and grievance records for the longer periods mandated by SEBI.
            </p>
          </section>

          {/* Section 7: Grievance Redressal */}
          <section className="privacy-section">
            <h2>7. Grievance Redressal</h2>

            <p>
              If You have a complaint or grievance regarding the App or Our services, you may raise it through the following matrix:
            </p>

            <h3>7.1 Grievance Redressal Matrix</h3>

            <table className="grievance-table" aria-label="Grievance Redressal Matrix with Contact Information">
              <thead>
                <tr>
                  <th scope="col">Level</th>
                  <th scope="col">Name & Designation</th>
                  <th scope="col">Contact Details</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Level 1</td>
                  <td>Kumari Priyadarshini<br />Investor Relations</td>
                  <td>
                    Email: <a href="mailto:ir@agreyacapital.com">ir@agreyacapital.com</a><br />
                    Contact: +91 9611157455
                  </td>
                </tr>
                <tr>
                  <td>Level 2</td>
                  <td>Krishnan MV<br />Compliance Officer</td>
                  <td>
                    Email: <a href="mailto:krishnan@agreyacapital.com">krishnan@agreyacapital.com</a><br />
                    Contact: +91 97314 55558
                  </td>
                </tr>
                <tr>
                  <td>Level 3</td>
                  <td>Vivek Vasudevan<br />Principal Officer</td>
                  <td>
                    Email: <a href="mailto:vivek@agreyacapital.com">vivek@agreyacapital.com</a><br />
                    Contact: +91 97311 60606
                  </td>
                </tr>
              </tbody>
            </table>

            <p>
              If an investor is not satisfied with the resolution provided through various channels or the method of handling complaints by Company; they can escalate the issues to SEBI Complaints Redress System (SCORES). Investors can lodge their grievances / complaints through the SCORES link <a href="https://scores.sebi.gov.in/scores-home" target="_blank" rel="noopener noreferrer">https://scores.sebi.gov.in/scores-home</a>. Toll Free Helpline: 1800 266 7575
            </p>

            <p>
              Investors may also send their physical complaints to: Office of Investor Assistance and Education, Securities and Exchange Board of India, SEBI Bhavan. Plot No.C4-A, 'G' Block, Bandra-Kurla Complex, Bandra (E), Mumbai - 400 051
            </p>

            <h3>7.2 Dispute Settlement</h3>

            <p>
              Any dispute, difference or claim arising out of or relating to this Agreement, or the breach thereof, if unable to be resolved by the Parties, shall be finally settled by arbitration under the Arbitration and Conciliation Act, 1996 or any statutory amendments thereof or any statute enacted for replacement thereof and shall be referred to the sole arbitration of a Person to be mutually nominated / appointed by both the Parties. The arbitral award shall be in writing and shall state the reasons upon which it is based. The award shall be final and binding on the Parties. The award may include an award of costs, including reasonable attorneys' fees and disbursements. The place of arbitration shall be Bengaluru, Karnataka and arbitration shall be conducted in English language.
            </p>

            <p>
              If the client is not satisfied, they can initiate dispute resolution through the Online Dispute Resolution Portal (ODR) at <a href="https://smartodr.in/login" target="_blank" rel="noopener noreferrer">https://smartodr.in/login</a>
            </p>

            <p>
              Alternatively, the client can directly initiate dispute resolution through the ODR Portal if the grievance lodged with the Portfolio Manager is not satisfactorily resolved or at any stage of the subsequent escalations mentioned above.
            </p>
          </section>

          {/* Section 8: Disclosure and Sharing of Data */}
          <section className="privacy-section">
            <h2>8. Disclosure and Sharing of Data</h2>

            <h3>8.1 Service Providers We use</h3>
            <p>
              We engage the following categories of Service Providers to operate the App. We share only the minimum data necessary for each provider to perform its function:
            </p>

            <table className="service-providers-table" aria-label="Service Providers Table with Data Sharing Details">
              <thead>
                <tr>
                  <th scope="col">Service Provider</th>
                  <th scope="col">Purpose</th>
                  <th scope="col">Data shared / location</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>WhatsApp Business Platform (Meta)</td>
                  <td>Delivering OTP messages for App login</td>
                  <td>Your registered mobile number and the OTP message are transmitted to Meta's WhatsApp Business Platform for delivery. This processing occurs outside India (see Section 8.2 for cross-border transfer details).</td>
                </tr>
                <tr>
                  <td>Firebase Cloud Messaging (Google)</td>
                  <td>Delivering push notifications (e.g., report-ready alerts, query updates)</td>
                  <td>A device push-notification token (not linked to Your name or number by Firebase) is shared with Google to route notifications to Your device. This processing may occur outside India, per Google's standard Firebase infrastructure.</td>
                </tr>
                <tr>
                  <td>Amazon Web Services (AWS) region</td>
                  <td>Primary application hosting and database</td>
                  <td>All App backend data — session data, query content, usage logs — is hosted on servers located in India (AWS data center).</td>
                </tr>
              </tbody>
            </table>

            <p>
              We do not share App data with any party for marketing or advertising purposes, and We do not sell Personal Data.
            </p>

            <h3>8.2 Cross-border transfer of data</h3>
            <p>
              To deliver login OTPs, your registered mobile number and the OTP message pass through Meta's WhatsApp Business Platform, which processes this data outside India as part of message delivery. This is currently the only element of the App's data flow that routes outside India; Our application servers and databases (AWS) remain India-hosted.
            </p>

            <p>
              Under the DPDPA, 2023, the Central Government may notify countries to which transfer of personal data is restricted; as of the date of this Policy, transfers in connection with standard global messaging infrastructure such as WhatsApp are not restricted under any such notification. We have assessed this transfer as necessary and proportionate to provide secure, reliable OTP delivery, and Meta's WhatsApp Business Platform is bound by its own data processing terms as a global messaging service provider.
            </p>
          </section>

          {/* Section 9: Data Storage and Cybersecurity */}
          <section className="privacy-section">
            <h2>9. Data Storage and Cybersecurity</h2>

            <p>
              As a SEBI-registered Portfolio Manager, the Company is subject to SEBI's Cybersecurity and Cyber Resilience Framework (CSCRF). In line with this framework:
            </p>

            <ul className="security-list">
              <li>Our application servers and databases are hosted on Amazon Web Services (AWS), within India. Client data at rest resides on India-based infrastructure.</li>
              <li>The only data flow that routes outside India is OTP delivery via the WhatsApp Business Platform (Meta) and, potentially, push-notification routing via Firebase (Google).</li>
              <li>Data is encrypted at rest and in transit using industry-standard encryption.</li>
              <li>Access to App backend systems is restricted to authorized personnel on a need-to-know basis.</li>
              <li>The Company maintains incident response procedures aligned with SEBI's CSCRF and will report reportable cybersecurity incidents to SEBI and/or CERT-In within the timelines prescribed by applicable regulation.</li>
            </ul>

            <p>
              While We follow commercially reasonable and regulation-aligned security measures, no method of electronic transmission or storage is completely secure, and We cannot guarantee absolute security.
            </p>
          </section>

          {/* Section 10: Your Rights as a Data Principal */}
          <section className="privacy-section">
            <h2>10. Your Rights as a Data Principal</h2>

            <p>
              Under the DPDPA, 2023, You have the right to:
            </p>

            <ul className="data-rights-list">
              <li>Access the Personal Data We hold about You in connection with the App.</li>
              <li>Seek correction or updating of inaccurate or incomplete data.</li>
              <li>Seek erasure of Personal Data that is no longer necessary for the purpose it was collected, subject to Our regulatory retention obligations under SEBI regulations (see Section 6).</li>
              <li>Withdraw consent for App-based processing at any time, without affecting the lawfulness of processing carried out before withdrawal, or our separate obligations under Your PMS agreement.</li>
              <li>Nominate another individual to exercise these rights on Your behalf in the event of death or incapacity.</li>
              <li>Register a grievance with Us, and if unresolved, with the Data Protection Board of India.</li>
            </ul>

            <p>
              To exercise any of these rights, contact Our Compliance Officer at the details in Section 7.1.
            </p>
          </section>

          {/* Section 11: Cookies and Tracking Technologies */}
          <section className="privacy-section">
            <h2>11. Cookies and Tracking Technologies</h2>

            <p>
              The App may use minimal session-management technologies (such as secure session tokens) strictly necessary to keep You logged in during Your session. The App does not use third-party advertising cookies or cross-app tracking technologies.
            </p>
          </section>

          {/* Section 12: Changes to This Privacy Policy */}
          <section className="privacy-section">
            <h2>12. Changes to This Privacy Policy</h2>

            <p>
              We may update this Privacy Policy from time to time to reflect changes in the App, our practices, or applicable law (including SEBI circulars and amendments to the DPDPA). We will notify You of material changes through the App and/or by email and will update the "Last updated" date above. Continued use of the App after such changes constitutes Your acknowledgment of the revised Policy.
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      {/* <Footer /> */}
    </>
  );
}
